export default {
  "menu.CompanyUpdatePage": "场所信息管理",
}